import ApplicationAdapter from './application';

export default class Client extends ApplicationAdapter {
  namespace = 'auth/v4';
}
